module.exports = __webpack_public_path__ + "assets/img/wujieguo.1df9ebc3.png";